import { Component } from '@angular/core';
import { AuthRoles } from 'src/app/auth/auth.types';
import { InfoReportGuard } from 'src/app/info-reports/info-report.guard';
import { LoaderService } from 'src/app/services/loader.service';
import { AuthorizationModel } from '../../models/authorization-model';

@Component({
  selector: 'ness-left-navigation',
  templateUrl: './left-navigation.component.html',
  styleUrls: ['./left-navigation.component.scss']
})
export class LeftNavigationComponent {
  loaderStatus: boolean[] = [];
  readonly canImport: AuthorizationModel = {
    role: [],
    authOrgCode: null,
    userType: [],
    roleUserType: [
      { roles: ['NESS Administrator', 'Application Administrator', 'Power User'], userType: 'ATFHQ'},
      { roles: ['NESS Administrator', 'Application Administrator', 'Power User'], userType: 'ATFFieldDivision' },
      { roles: ['NESS Administrator'], userType: 'StateLocalLE' }
    ]
  } as AuthorizationModel;
  readonly hasAdmin: AuthRoles[] = ['Application Administrator', 'NESS Administrator'];
  readonly hasPowerUser: AuthRoles[] = ['Power User'];
  readonly hasCDSApprover: AuthRoles[] = ['CDS Approver'];
  readonly canExport: AuthorizationModel = {
    role: [],
    authOrgCode: null,
    userType: [],
    roleUserType: [
      { roles: ['Application Administrator', 'Power User', 'Editor', 'NESS Administrator'], userType: 'ATFHQ'},
      { roles: ['Application Administrator', 'Power User', 'Editor', 'NESS Administrator'], userType: 'ATFFieldDivision' },
      { roles: ['Application Administrator', 'Editor'], userType: 'StateLocalLE' },
      { roles: ['NESS Administrator'], userType: 'StateLocalLE' }
    ]
  } as AuthorizationModel;
  readonly canMerge: AuthorizationModel = {
    role: [],
    authOrgCode: null,
    userType: [],
    roleUserType: [
      {
        roles: ['Application Administrator', 'Power User', 'NESS Administrator'],
        userType: 'ATFHQ'
      },
      {
        roles: ['Application Administrator', 'Power User', 'NESS Administrator'],
        userType: 'ATFFieldDivision'
      },
      {
        roles: ['NESS Administrator'],
        userType: 'StateLocalLE'
      }
    ]
  } as AuthorizationModel;
  canViewIR: AuthorizationModel = null;

  constructor(private infoReportGuard: InfoReportGuard,
    public loaderService: LoaderService) {
    Promise.resolve(this.infoReportGuard.hasIRAssignment(false)).then((val) => {
      this.canViewIR = {
        role: [],
        authOrgCode: null,
        userType: [],
        roleUserType: [
          {
            roles: ['Application Administrator', 'Power User', 'Editor', 'Viewer', 'NESS Administrator'],
            userType: 'ATFHQ'
          },
          {
            roles: ['Application Administrator', 'Power User', 'Editor', 'Viewer', 'NESS Administrator'],
            userType: 'ATFFieldDivision'
          },
          {
            roles: (val ? ['Application Administrator', 'Power User', 'Editor', 'Viewer', 'NESS Administrator'] : ['NESS Administrator']),
            userType: 'StateLocalLE'
          }
        ]
      } as AuthorizationModel;
    });
  }
}
